module.exports = __webpack_public_path__ + "static/banner-horizontal-sumate-0ccf49186b8a9c7015976916a06d3f34.gif";